import { z } from 'zod';

export type StatisticsSummaryValue = z.infer<typeof statisticsSummaryValueSchema>;

/**
 * Represents a summary of statistical data with a value and its difference to a previous period.
 */
export const statisticsSummaryValueSchema = z.object({
  /** The metric measured for the current period */
  value: z.number(),
  /** The metric measured for the diff period */
  diff: z.number(),
  /** The percentage change between the current and diff periods */
  change: z.number(),
});
